import { Stack, Typography } from '@mui/material';

import { TextField } from '~components/atoms/form';

type Props = {
  stationImgUrl?: string;
  stationTitle?: string;
  stationImei?: string;
};

export const AddPlacementNameStep: React.FC<Props> = ({
  stationImgUrl,
  stationTitle,
  stationImei,
}) => {
  return (
    <Stack gap={2}>
      <Typography variant="h6" fontWeight={600}>
        Where is this station placed?
      </Typography>
      <Stack direction={'row'} gap={2} alignItems="center">
        <img
          src={stationImgUrl}
          alt="station"
          width={64}
          height={64}
          style={{
            backgroundColor: '#EFF2F6',
            borderRadius: '8px',
          }}
        />
        <Stack gap={1}>
          <Typography variant="body1" fontWeight={400}>
            {stationTitle}
          </Typography>
          <Typography variant="body1" fontWeight={400}>
            {`IMEI: ${stationImei}`}
          </Typography>
        </Stack>
      </Stack>
      <TextField
        label={
          <Typography variant="body2" fontWeight={400}>
            Placement name
          </Typography>
        }
        name={'placement.name'}
        defaultHelperText={`Enter a location reference.\n(e.g., Bar Counter, East Entrance, Sec. 12 Stairs).`}
      />
    </Stack>
  );
};
